/**
 * 404 Not Found page displayed when a route does not match any known path.
 *
 * @module pages/NotFound
 * @author Covintus
 * @author Snowfly
 * @version 1.0.0
 */
import React from 'react';

/**
 * Renders a simple 404 message for unmatched routes.
 *
 * @component
 * @returns {JSX.Element} A heading with a 404 message.
 */
const NotFound = () => (
  <div>
    <h1>404! Page Not found</h1>
  </div>
);

export default NotFound;
